import { Component, Prop, Element } from '@stencil/core';

@Component({
  tag: 'aafp-link-pile-column',
  shadow: false,
})
export class AafpLinkPileColumn {
  @Prop() nodes: HTMLElement[];
  @Element() element: HTMLElement;

  render() {
    return this.nodes.map(node => {
      this.element.appendChild(node);
    });
  }
}
